import { UpdateTenantUserRequestSchema, UpdateTenantUserResponseSchema } from './update-tenant-user.schema';
/**
 * Update Tenant User Endpoint Contract
 * Updates a tenant user's information (super-admin only)
 */ export const updateTenantUserContract = {
    method: 'PATCH',
    path: '/api/v2/tenants/:tenantId/users/:userId',
    description: 'Update a tenant user by ID',
    requestSchema: UpdateTenantUserRequestSchema,
    responseSchema: UpdateTenantUserResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'User or tenant not found',
            409: 'Conflict - a concurrent change rebound the identity during a home-org move',
            503: 'Service Unavailable - identity provider unreachable during home-org move'
        }
    }
};

//# sourceMappingURL=update-tenant-user.contract.js.map